<template>
    <ErrorPage>
        <template slot="Title">
            No result found
        </template>
        <template slot="Content">
            Try a new search
        </template>
    </ErrorPage>
</template>

<script>
    import ErrorPage from'@/components/common/ErrorPage.vue'
    import  UploadButton from "@/components/Library/UploadButton"
    export default {
        name: "TrackListNotFound",
        components: {
            ErrorPage,UploadButton
        },
    }
</script>

<style scoped>
</style>